import { useQuery } from '@tanstack/react-query'
import {
  isUserAdminInSociety,
  isUserBoardMemberInSociety,
} from '../../../helpers/society'
import { useAuth } from '../../../hooks/useAuth'
import { societyQueries } from '../../../api/societies'

export const useAdminOrBoardMemberInAtLeastOneSociety = (): boolean => {
  const { userId } = useAuth()
  const { data: societies } = useQuery(societyQueries.getUserSocieties(userId))

  if (!societies) return false

  return societies
    ?.map(
      (_society) =>
        isUserAdminInSociety(_society, userId as string) ||
        isUserBoardMemberInSociety(_society, userId as string)
    )
    .includes(true)
}
